<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="content_main" style="background-color: #fff; padding: 20px 0; min-height: 500px;">
					<div class="login_main">
						<el-row>
							<el-col :span="4">
								<UserLeft></UserLeft>
							</el-col>
							<el-col :span="20">
								
								<div class="neirong_line_region" style="margin-top: 20px; margin-bottom: 30px;">
									<el-breadcrumb separator-class="el-icon-arrow-right">
									  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
									  <el-breadcrumb-item>控制台</el-breadcrumb-item>
									  <el-breadcrumb-item>我的信息</el-breadcrumb-item>
									</el-breadcrumb>
								</div>
								
								<div class="neirong_line_region">
									<div class="neirong_line_split"></div>
								</div>
								
								<div class="neirong_line_region">
									<div class="neirong_line_title" style="font-size: 14px; height: 80px;">
										<el-row>
											<el-col :span="5">用户类型：{{user_type_text}}</el-col>
											<el-col :span="7">有效期开始：{{user_period.startTime}}</el-col>
											<el-col :span="7">有效期截止：{{user_period.endTime}}</el-col>
											<el-col :span="4" :offset="1" style="text-align: right;">
												<el-button type="primary" plain size="mini" @click="addUser()" :disabled="is_disabled_add == 0 || is_disabled_add == 1"> 新增子账号 </el-button>
											</el-col>
										</el-row>
										<el-row>
											<el-col :span="3">USERID：{{cur_user.id}}</el-col>
											<el-col :span="8">USERCODE：{{cur_user.openidmp}}</el-col>
											<!-- 2024年9月19日限制子账号数量15个 -->
											<el-col :span="7">子账号数量：{{total}}，剩余数量{{ 15-total }}</el-col>
										</el-row>
									</div>
									<div class="neirong_line_split"></div>
								</div>
								
								<div class="neirong_line_region">
									<div class="neirong_line_title" style="font-weight: bold;">
										<!-- <div class="neirong_line_title_icon"></div> -->
										<el-row>
											<el-col :span="7">子账号编码</el-col>
											<el-col :span="4">有效期开始时间</el-col>
											<el-col :span="5">有效期截止时间</el-col>
											<el-col :span="4">子账号创建时间</el-col>
											<el-col :span="4">操作</el-col>
										</el-row>
									</div>
									<div class="neirong_line_split"></div>
								</div>
								
								<el-empty description="没有子账号记录..." v-show="is_show_empty"></el-empty>
								
								<div class="neirong_line_region" v-for="(item, index) in list_record">
									<div class="neirong_line_title">
										<!-- <div class="neirong_line_title_icon"></div> -->
										<el-row>
											<el-col :span="7">{{item.userName}} {{ item.userMarkName }}</el-col>
											<el-col :span="4">{{item.startTime}}</el-col>
											<el-col :span="5">{{item.endTime}}</el-col>
											<el-col :span="4">{{item.createdOn}}</el-col>
											<el-col :span="2">
												<el-popconfirm title="确定取消子账号吗？" @confirm="cansoleSon(item.id)">
													<el-button type="primary" plain round size="mini" icon="el-icon-close" slot="reference">取消</el-button>
												</el-popconfirm>
											</el-col>
											<el-col :span="2">
												<el-button type="success" plain round size="mini" icon="el-icon-collection" @click="setUserMarkName(item.id)">备注名</el-button>
											</el-col>
										</el-row>
									</div>
									<!-- <div class="neirong_line_summary">
									</div> -->
									<div class="neirong_line_split"></div>
								</div>
								
								<div class="neirong_line_page" style="text-align: center;">
									<el-pagination
									  background
									  layout="prev, pager, next, jumper"
									  :total="total"
									  @current-change="handlePage"
									  >
									</el-pagination>
								</div>
								
							</el-col>
						</el-row>
					</div>
				</div>
				
				
				
				<el-dialog @close = "closeDialog()"
				  title="新增子账号"
				  :visible.sync="addUserDialog"
				  :destroy-on-close = 'true'
				  width="30%">
				  <span>
					  <el-row>
					  	<el-col :span="20" :offset="2">
					  		<div class="login_qrcode">
					  			<div class="login_qrcode_title">
					  				子账号用户微信扫码获取权限
					  			</div>
					  			<div class="login_qrcode_img">
					  				<el-image :src="login_qrcode" fit="contain" style="width: 250px;">
					  					<div slot="error" class="image-slot">
					  					</div>
					  				</el-image>
					  				<div class="login_qrcode_summary">
					  					让子账号用户打开手机微信扫一扫 获取权限
					  				</div>
					  			</div>
					  		</div>
					  	</el-col>
					  </el-row>
				  </span>
				  <!-- <span slot="footer" class="dialog-footer">
				    <el-button @click="kaipiaoDialog = false">取 消</el-button>
				    <el-button type="primary" @click="kaipiaoSubmit">确 定</el-button>
				  </span> -->
				</el-dialog>
				
				
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	import UserLeft from '../components/userLeft.vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
			UserLeft,
		},
		data() {
			return {
				cur_user: {},
				is_show_empty: false,
				list_record: [], // 数据列表
				pi: 1, // 当前页码
				total: 0, //数据总数
				
				fullscreenLoading: false,
				
				user_period: {dictUserType: 0, startTime: '', endTime: ''},
				user_type_text: '',
				
				addUserDialog: false,
				
				login_uuid: '',
				login_qrcode: '',
				count: 0,
				
				is_disabled_add: 0,
				
			}
		},
		
		created() {
			// console.log('用户状态已保存1', localStorage.getItem('cur_user'))
			// console.log('用户状态已保存2', JSON.parse(localStorage.getItem('cur_user')))
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
			
			this.cur_user = JSON.parse(localStorage.getItem('cur_user'));
			// console.log(this.cur_user);
			if (this.cur_user == null || this.cur_user == {}) {
				this.$message({
					message: '未登录用户，请登陆后进入控制台',
					type: 'error',
				});
				setTimeout(()=>{
					this.toUrlCur('login')
				}, 1500)
			} else {
				this.loadData();
				this.loadUserPeriod();
			}
		},
		
		methods: {
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					// this.$router.push({path: url})
					let route_data = this.$router.resolve({path: url})
					// console.log(route_data)
					window.open(route_data.href, '_blank')
				}
			},
			toUrlCur(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					this.$router.push({path: url})
				}
			},
			
			// 加载数据
			loadData() {
				this.fullscreenLoading = true
				this.list_record = [] // 先设置成空有个视觉切换效果
				let url = this.$common.apiUrl + 'pub_user_payment/listByParentUserId'
				let client_data = this.$qs.stringify({parentUserId: this.cur_user.id, pi: this.pi})
				this.$axios.post(url, client_data).then((res)=>{
					console.log(res.data)
					this.fullscreenLoading = false
					this.list_record = res.data.data.rows
					this.total = res.data.data.total
					if (this.list_record == 0) {
						this.is_show_empty = true
					} else {
						this.is_show_empty = false
					}
					this.is_disabled_add += 1;
				})
			},
			
			// 清空搜索框时
			clearInput() {
				if (this.keyword == '') {
					this.pi = 1
					this.loadData()
				}
			},
			
			// 点击分页触发事件
			handlePage(page) {
				// console.log(page)
				this.pi = page
				this.loadData()
				document.documentElement.scrollTop = 0;
			},
			
			// 取消子账号
			cansoleSon(id) {
				let url = this.$common.apiUrl + 'pub_user_payment/cansoleSon'
				let client_data = this.$qs.stringify({id: id})
				this.$axios.post(url, client_data).then((res)=>{
					this.$message.success('已取消子账号权限')
					// this.loadData()
					setTimeout(()=>{
						window.location.reload();
					}, 800)
				})
			},
			
			
			// 加载用户类型和到期日期
			loadUserPeriod() {
				let url = this.$common.apiUrl + 'pub_user_period/detail'
				let client_data = this.$qs.stringify({userId: this.cur_user.id})
				this.$axios.post(url, client_data).then((res)=>{
					// console.log(res.data.data)
					if (res.data.data) {
						this.user_period = res.data.data
						switch (this.user_period.dictUserType) {
							case 1: 
								this.user_type_text = '3天体验用户'
								break
							case 10: 
								this.user_type_text = '1人版 16800'
								break
							case 11: 
								this.user_type_text = '2人版 21600'
								break
							case 12: 
								this.user_type_text = '3人版 26400'
								break
							case 19: 
								this.user_type_text = '多人版 38000'
								break
							case 110: 
								this.user_type_text = '1年会员 16800'
								break
							case 113: 
								this.user_type_text = '3年会员 36800'
								break
							case 115: 
								this.user_type_text = '永久会员 56800'
								break
							case 0:
								this.user_type_text = '子用户'
								break
						}
						this.is_disabled_add += 1;
					} else {
						this.user_type_text = '-'
						this.user_period.startTime = '-'
						this.user_period.endTime = '-'
					}
				})
			},
			
			
			// 点击新增子用户
			addUser() {
				console.log('用户类型：', this.user_period.dictUserType, '子账号数量：', this.total);
				// 2024年9月19日限制子账号数量15个
				if (this.total >= 15) {
					this.$message.warning('子账号已满，无法新增，当前已有个' + this.total + '账号')
					return
				}
				if (this.user_period.dictUserType == 0) {
					this.$message.warning('子用户类型无权增加子用户，请使用付款账号添加')
				} else if (this.user_period.dictUserType == 10) {
					this.$message.warning('单用户版，无法新增子账号')
				} else {
					if (this.user_period.dictUserType == 11) {
						if (this.total >= 1) {
							this.$message.warning('子账号已满，无法新增')
						} else {
							this.createQrcode();
							this.addUserDialog = true;
						}
					}
					if (this.user_period.dictUserType == 12) {
						if (this.total >= 2) {
							this.$message.warning('子账号已满，无法新增')
						} else {
							this.createQrcode();
							this.addUserDialog = true;
						}
					}
					if (this.user_period.dictUserType == 19) {
						this.createQrcode();
						this.addUserDialog = true;
					}
					if (this.user_period.dictUserType == 110) {
						this.createQrcode();
						this.addUserDialog = true;
					}
					if (this.user_period.dictUserType == 113) {
						this.createQrcode();
						this.addUserDialog = true;
					}
					if (this.user_period.dictUserType == 115) {
						this.createQrcode();
						this.addUserDialog = true;
					}
				}
				
			},
			
			// 创建分配子账号二维码
			createQrcode() {
				let url = 'https://sudomanage.qqbd.vip/api/wx/mp/biz/wxe4ad8c0c1dc709c6/createQrcodeSon'
				// let url = 'http://localhost:58080/api/wx/mp/biz/wxe4ad8c0c1dc709c6/createQrcodeSon' // 如果使用本地测试，出现二维码后修改数据库is_scan和scan_user_id字段用于模拟用户扫码登录
				this.$axios.get(url).then((res)=>{
					console.log(res.data.data)
					this.count = 0
					this.login_uuid = res.data.data.uuid
					this.login_qrcode = res.data.data.url
					this.checkQrcode()
				})
			},
			
			
			// 定时监测二维码状态是否扫描更新
			checkQrcode() {
				let task = setInterval(() => {
					this.count += 1
					let url = this.$common.apiUrl + 'pub_login_qrcode/detail/' + this.login_uuid
					this.$axios.get(url).then((res)=>{
						// console.log('扫码数据：',res.data.data)
						let status = res.data.data.isScan
						if (status == '1') {
							console.log('is_scan')
							clearInterval(task)
							let scan_user_id = res.data.data.scanUserId
							// 分配已扫描用户作为子账号
							this.userSonSet(scan_user_id, this.cur_user.id)
						} else {
							// console.log('未扫码')
							console.log(this.count)
							if (this.count >= 90) {
								console.log('已超时，停止获取二维码数据')
								clearInterval(task)
							}
						}
					})
				}, 2000)
			},
			
			// 分配已扫码用户为子账号，这里进行逻辑处理，处理完后自动关闭并刷新列表
			userSonSet(scan_user_id, parent_user_id) {
				console.log('扫码用户：', scan_user_id, '被扫码用户：', parent_user_id)
				let url = this.$common.apiUrl + 'pub_user_payment/addSonUser'
				let client_data = this.$qs.stringify({userId: scan_user_id, parentUserId: parent_user_id})
				this.$axios.post(url, client_data).then((res)=>{
					// console.log(res.data.data)
					this.$message.success('新增子用户成功');
					setTimeout(()=>{
						window.location.reload();
					}, 800)
				})
				
			},
			
			// 关闭子账号二维码时回调
			closeDialog() {
				console.log('关闭dialog')
				location.reload()
			},
			
			// 设置备注名
			setUserMarkName(id) {
				this.$prompt('请填写备注名', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(({ value }) => {
					let url = this.$common.apiUrl + 'pub_user_payment/setUserMarkName'
					let client_data_json = {'id': id, 'userMarkName': value}
					let client_data = this.$qs.stringify(client_data_json)
					this.$axios.post(url, client_data).then((res)=>{
						console.log('update pub_user_payment setUserMarkName, affcted rows is: ', res.data)
						if (res.data.data > 0) {
							// console.log('success...')
							this.$message({
								message: '保存备注名成功',
								type: 'success'
							})
							this.loadData()
						}
					})
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '取消输入'
					// });
				});
			},
			
			
		}
	}
</script>

<style scoped>
	.neirong_line_region {
		/* border: 1px solid red; */
		width: 93%;
		padding: 0px 4%;
		margin-left: 2%;
	}
	
	.neirong_line_summary {
		text-align: right;
	}
	
	.neirong_line_title {
		font-size: 14px;
	}
</style>